<template>
    <div>
        <card-header title="New Plan Note" icon="fa-message-plus" />

        <card-body padded>
            <quill-editor v-model="newNote.note" ref="descriptionEditor" :options="editorOptions" class="has-background-white content" />
            <b-switch v-model="sendNotification">Dispatch Notification E-Mails (Internal)</b-switch>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newNote.note"
                    ><i class="fas fa-plus mr-2"></i>New Note
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from "@/http_client";
    import PlanTransactionForm from "./PlanTransactionForm";
    import moment from "moment";

    export default {
        components: {PlanTransactionForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newNote: {},
                editorOptions: {},
                sendNotification: true
            };
        },
        methods: {
            submit: function () {
                this.$emit('loading', true);

                let payload = {
                    note: this.newNote.note,
                    plan_id: this.props.planId,
                    user_id: this.props.userId,
                    send_notification: this.sendNotification
                };

                http.post(`payment-plans/${this.props.planId}/notes`, payload, {force: true}).then(response => {
                    this.$reloadCard('payment-plan', {planId: this.props.planId});
                    this.$reloadCard('plan-notes', {planId: this.props.planId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the transaction.');
                    this.$emit('loading', false);
                });
            }
        }
    };
</script>
